module.exports = __webpack_public_path__ + "static/media/hopkins.aa629c9d.png";